import { adminPolicy } from "./admin";

const miscPolicies = new Map([["payroll-verification", adminPolicy]]);

export default miscPolicies;
